import { MAP_SYMBOLS } from '@/lib/map-assets';

/**
 * Draws a symbol onto the given canvas context.
 * Utilizes processed symbol sheets if available, otherwise falls back to procedural vector drawing.
 *
 * @param ctx - The target canvas context
 * @param type - The ID of the symbol to draw (e.g. 'tree_oak', 'mountain_peak')
 * @param x - The center X coordinate
 * @param y - The center Y coordinate
 * @param size - The base size of the symbol (diameter/width)
 * @param processedSheets - The dictionary of pre-processed (transparent) image sheets
 */
export const drawSymbolShape = (
    ctx: CanvasRenderingContext2D,
    type: string,
    x: number,
    y: number,
    size: number,
    processedSheets: Record<string, HTMLCanvasElement | HTMLImageElement>
) => {
    const symbolDef = MAP_SYMBOLS.find(s => s.id === type);
    if (!symbolDef) return;

    // Draw Individual File Asset
    if (symbolDef.src && processedSheets[symbolDef.src]) {
        const img = processedSheets[symbolDef.src];

        // Calculate aspect ratio to preserve shape
        const aspect = img.width / img.height;
        let drawW = size;
        let drawH = size;

        if (aspect > 1) {
            // Wider than tall
            drawH = size / aspect;
        } else {
            // Taller than wide
            drawW = size * aspect;
        }

        ctx.save();
        ctx.translate(x, y);
        ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
        ctx.restore();
    }
};
